@if (mainFilename$ | async; as mainFilename) {
  <vhv-angebot
    *axLazyElement="'vhv-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></vhv-angebot>
}
